<template>
  <div class="campaign-metric">
    <div class="campaign-metric__type">
      {{ type }}
    </div>
    <div class="campaign-metric__price">
      {{ amount | capitalize }}<span v-if="type == 'cap'" class="campaign-metric__quantity">/wk</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignMetric',
  props: {
    type: {
      require: true
    },
    amount: {
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.campaign-metric {
  padding-right: $--clb-space-2;
  display: inline-block;
  min-width: 60px;

  &.disabled {
    color: $--clb-disabled-color;
  }

  &__price {
    font-weight: 700;
    font-size: $--font-size-base;
    color: #262626;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__quantity,
  &__type {
    color: $--clb-body-font;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__quantity {
    font-size: 10px;
    color: $--clb-camp-details-standards-color;
  }
}
</style>
